<template>
  <div>
    <a-menu mode="inline" :default-selected-keys="selectedKeys" :default-open-keys="defaultOpenKeys" :selected-keys="selectedKeys">
      <template v-for="menu in sideMenu">
        <!-- 渲染有多级的菜单，目前仅支持两级 -->
        <template v-if="menuChildren(menu).length > 0">
          <a-sub-menu :key="`0-${menu.id}`">
            <span slot="title">
              <a-icon v-if="menu.icon" :type="menu.icon" />
              <span>{{ menu.name }}</span>
            </span>
            <template v-for="menuItem in menu.children">
              <a-menu-item v-if="menuItem.hide == false" :key="`${menuItem.parent_id}-${menuItem.id}`">
                <router-link :to="{ name: menuItem.code }"> {{ menuItem.name }} </router-link>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>

        <!-- 渲染只有一级的菜单 -->
        <template v-else>
          <a-menu-item v-if="menu.hide == false" :key="`${menu.parent_id}-${menu.id}`">
            <router-link :to="{ name: menu.code }">
              <a-icon v-if="menu.icon" :type="menu.icon" />
              <span>{{ menu.name }}</span>
            </router-link>
          </a-menu-item>
        </template>
      </template>
    </a-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectId: parseInt(this.$route.params.project_id)
    };
  },
  computed: {
    sideMenu() {
      return this.$store.state.sideMenu;
    },
    selectedKeys() {
      // 三级路由时失效
      const route = this.$route;
      return [`${route.meta.parent_id}-${route.meta.id}`];
    },
    defaultOpenKeys() {
      return [`0-${this.$route.meta.parent_id}`];
    }
  },
  methods: {
    menuChildren(menu) {
      if (menu.children === undefined) {
        return [];
      }
      return menu.children.filter(function (item) {
        return item.show !== false; // 只返回偶数
      });
    }
  }
};
</script>
